const bcs:any = {
  //account: {sv:'account',lb:'Account',nm:'aci',vf:'rid',df:'nam',rf:'acn'},
  //accounttype: {sv:'accounttype',lb:'Account Type',nm:'ati',vf:'rid',df:'nam',rf:'atn'},
  //agenttype: {sv:'agenttype',lb:'Agent Type',nm:'ati',vf:'rid',df:'nam',rf:'atn'},
  //api: {sv:'api',lb:'API',nm:'api',vf:'rid',df:'nam',rf:'apn'},
  //apitype: {sv:'apitype',lb:'API Type',nm:'api',vf:'rid',df:'nam',rf:'apn'},
  branch: {sv:'branch',lb:'Branch',nm:'bri',vf:'rid',df:'nam',rf:'brn'},
  context: {sv:'context',lb:'Context',nm:'ctx',vf:'rid',df:'nam',rf:'ctx'},
  entity:{sv:'entity',lb:'Entity',nm:'eid',vf:'rid',df:'nam',rf:'enm'},
  inspectionentity:{sv:'entity',lb:'Entity',nm:'eid',vf:'rid',df:'nam',rf:'ens'},
  entitytype:{sv:'entitytype',lb:'EntityType',nm:'eti',vf:'rid',df:'nam',rf:'ety'},
  gender:{sv:'gender',lb:'Gender',nm:'gdi',vf:'rid',df:'nam',rf:'gdn'},
  loginstatus:{sv:'loginstatus',lb:'Login Status',nm:'lst',vf:'rid',df:'nam',rf:'lst'},
  loglevel:{sv:'loglevel',lb:'Log Level',nm:'lvi',vf:'rid',df:'nam',rf:'lvn'},
  role:{sv:'role',lb:'Role',nm:'roi',vf:'rid',df:'nam',rf:'rnm'},
  user:{sv:'user',lb:'User',nm:'usi',vf:'rid',df:'nam',rf:'unm'},

  //clearer:{sv:'clearer',lb:'Clearer',nm:'cri',vf:'rid',df:'nam',rf:'crn'},
  //client:{sv:'client',lb:'Cleint',nm:'lci',vf:'rid',df:'nam',rf:'cln'},
  configuration:{sv:'configuration',lb:'Configuration',nm:'cfi',vf:'rid',df:'nam',rf:'cfn'},
  country:{sv:'country',lb:'Country',nm:'coi',vf:'rid',df:'nam',rf:'coy'},
  currency:{sv:'currency',lb:'Currency',nm:'cui',vf:'rid',df:'nam',rf:'cur'},
  //customer:{sv:'customer',lb:'Customer',nm:'cid',vf:'rid',df:'nam',rf:'cnm'},
  dashtype:{sv:'dashtype',lb:'Dashtype',nm:'dti',vf:'rid',df:'nam',rf:'dtn'},
  district:{sv:'district',lb:'District',nm:'dsi',vf:'rid',df:'nam',rf:'dsn'},
  //fund:{sv:'fund',lb:'Fund',nm:'fui',vf:'rid',df:'nam',rf:'fun'},
  idtype:{sv:'idtype',lb:'ID Type',nm:'iti',vf:'rid',df:'nam',rf:'itn'},
  location:{sv:'location',lb:'Location',nm:'lci',vf:'rid',df:'nam',rf:'lcn'},
  inspectionlocation:{sv:'location',lb:'Location',nm:'lci',vf:'rid',df:'nam',rf:'lcc'},
  declarationstate:{sv:'declarationstate',lb:'Status',nm:'sti',vf:'rid',df:'nam',rf:'stc'},
  inspectionrisklevel:{sv:'inspectionrisklevel',lb:'Risk Level',nm:'rli',vf:'rid',df:'nam',rf:'rlc'},
  inspectionpriority:{sv:'inspectionpriority',lb:'Priority',nm:'pri',vf:'rid',df:'nam',rf:'prc'},
  itemquestion:{sv:'itemquestion',lb:'Question',nm:'qni',vf:'rid',df:'nam',rf:'nam'},
  declaration:{sv:'declaration',lb:'Declaration',nm:'dci',vf:'rid',df:'nam',rf:'dck'},
  //meterstatus:{sv:'meterstatus',lb:'Meter Status',nm:'msi',vf:'rid',df:'nam',rf:'msn'},
  //orderstatus:{sv:'orderstatus',lb:'Order Status',nm:'osi',vf:'rid',df:'nam',rf:'osn'},
  //productionstatus:{sv:'productionstatus',lb:'Production Status',nm:'psi',vf:'rid',df:'nam',rf:'psn'},
  //providertype:{sv:'providertype',lb:'Providertype',nm:'pti',vf:'rid',df:'nam',rf:'ptn'},
  region:{sv:'region',lb:'Region',nm:'rgi',vf:'rid',df:'nam',rf:'rgn'},
  report:{sv:'report',lb:'Report',nm:'rpi',vf:'rid',df:'nam',rf:'rpn'},
  //reportstatus:{sv:'reportstatus',lb:'Report Status',nm:'rsi',vf:'rid',df:'nam',rf:'rsn'},
  //requeststatus:{sv:'requeststatus',lb:'Request Status',nm:'rsi',vf:'rid',df:'nam',rf:'rsn'},
  //service:{sv:'service',lb:'Service',nm:'svi',vf:'rid',df:'nam',rf:'svn'},
  //servicemode:{sv:'servicemode',lb:'Service Mode',nm:'smi',vf:'rid',df:'nam',rf:'smn'},
  //servicetype:{sv:'servicetype',lb:'Servicetype',nm:'sti',vf:'rid',df:'nam',rf:'stn'},
  //settlementstatus:{sv:'settlementstatus',lb:'Settlementstatus',nm:'rpi',vf:'rid',df:'nam',rf:'rpn'},
  //transactionstatus:{sv:'transactionstatus',lb:'Transactionstatus',nm:'xsi',vf:'rid',df:'nam',rf:'xsn'},
  //transactiontype:{sv:'report',lb:'Transactiontype',nm:'xti',vf:'rid',df:'nam',rf:'xtn'},

  activitystate:{sv:'activitystate',lb:'Activity State',nm:'asi',vf:'rid',df:'nam',rf:'asn'},
  activitytype:{sv:'activitytype',lb:'Activity Type',nm:'ati',vf:'rid',df:'nam',rf:'atn'},
  customertype:{sv:'customertype',lb:'Customer Type',nm:'cti',vf:'rid',df:'nam',rf:'ctn'},
  devicetype:{sv:'devicetype',lb:'Device Type',nm:'dti',vf:'rid',df:'nam',rf:'dtn'},
  eventstate:{sv:'eventstate',lb:'Event State',nm:'vsi',vf:'rid',df:'nam',rf:'vsn'},
  eventtype:{sv:'eventtype',lb:'Event Type',nm:'vti',vf:'rid',df:'nam',rf:'vtn'},
  notificationstate:{sv:'notificationstate',lb:'Notification State',nm:'nsi',vf:'rid',df:'nam',rf:'nsn'},
  notificationtype:{sv:'notificationtype',lb:'Notification Type',nm:'nti',vf:'rid',df:'nam',rf:'ntn'},
  requeststate:{sv:'requeststate',lb:'Request State',nm:'rsi',vf:'rid',df:'nam',rf:'rsn'},
  requesttype:{sv:'requesttype',lb:'Request Type',nm:'rti',vf:'rid',df:'nam',rf:'rtn'},
  reviewstate:{sv:'reviewstate',lb:'Review State',nm:'wsi',vf:'rid',df:'nam',rf:'wsn'},
  reviewtype:{sv:'reviewtype',lb:'Review Type',nm:'wti',vf:'rid',df:'nam',rf:'wtn'},
  inspector:{sv:'inspector',lb:'Inspector',nm:'nsi',vf:'rid',df:'nam',rf:'nsn'},
  authoriser:{sv:'inspector',lb:'Inspector',nm:'ati',vf:'rid',df:'nam',rf:'atn'},
  issuer:{sv:'inspector',lb:'Inspector',nm:'isi',vf:'rid',df:'nam',rf:'isn'},
  inspection:{sv:'inspection',lb:'Inspection',nm:'ini',vf:'rid',df:'nam',rf:'inc'},
  severity:{sv:'severity',lb:'Severity',nm:'svi',vf:'rid',df:'nam',rf:'svc'},
  violation:{sv:'violation',lb:'Violation',nm:'vii',vf:'rid',df:'nam',rf:'vic'},
  inspectiontype:{sv:'inspectiontype',lb:'Inspection Type',nm:'iti',vf:'rid',df:'nam',rf:'itc'},
  inspectionstate:{sv:'inspectionstate',lb:'State',nm:'sti',vf:'rid',df:'nam',rf:'stc'},
  itemstate:{sv:'itemstate',lb:'State',nm:'sti',vf:'rid',df:'nam',rf:'stc'},
  directivestate:{sv:'directivestate',lb:'State',nm:'dsi',vf:'rid',df:'nam',rf:'dsc'},
  findingstate:{sv:'findingstate',lb:'State',nm:'fsi',vf:'rid',df:'nam',rf:'fsc'},
  finding:{sv:'finding',lb:'Finding',nm:'fdi',vf:'rid',df:'nam',rf:'fdt'},
  itemtype:{sv:'itemtype',lb:'Type',nm:'iti',vf:'rid',df:'nam',rf:'itc'},
  inspectortype:{sv:'inspectortype',lb:'Type',nm:'iti',vf:'rid',df:'nam',rf:'itc'},
  inspectorrole:{sv:'inspectorrole',lb:'Role',nm:'iri',vf:'rid',df:'nam',rf:'irc'},
  team:{sv:'team',lb:'Team',nm:'tid',vf:'rid',df:'nam',rf:'tsc'},
  teamrole:{sv:'teamrole',lb:'Role',nm:'rli',vf:'rid',df:'nam',rf:'rsc'},
  teammember:{sv:'teammember',lb:'Team',nm:'tmi',vf:'rid',df:'nam',rf:'tmi'},
  messagetype:{sv:'messagetype',lb:'Type',nm:'mti',vf:'rid',df:'nam',rf:'mtn'},
  messagemode:{sv:'messagemode',lb:'Mode',nm:'mmi',vf:'rid',df:'nam',rf:'mmn'},
  messagechannel:{sv:'messagechannel',lb:'Channel',nm:'mci',vf:'rid',df:'nam',rf:'mcn'},
  messagestate:{sv:'messagestate',lb:'State',nm:'msi',vf:'rid',df:'nam',rf:'msn'},
  contacttype:{sv:'contacttype',lb:'Type',nm:'cti',vf:'rid',df:'nam',rf:'ctn'},
  linker:{sv:'contact',lb:'Linker',nm:'rci',vf:'rid',df:'nam',rf:'rcn'},
  linked:{sv:'contact',lb:'Linked',nm:'dci',vf:'rid',df:'nam',rf:'dcn'},
  linktype:{sv:'linktype',lb:'Type',nm:'lti',vf:'rid',df:'nam',rf:'ltc'},
  enquirytype:{sv:'enquirytype',lb:'Type',nm:'eti',vf:'rid',df:'nam',rf:'etn'},
  enquirychannel:{sv:'enquirychannel',lb:'Channel',nm:'eci',vf:'rid',df:'nam',rf:'ecn'},
  enquirystate:{sv:'enquirystate',lb:'State',nm:'esi',vf:'rid',df:'nam',rf:'esn'},
  
  event:{sv:'event',lb:'Event',nm:'evi',vf:'rid',df:'nam',rf:'evn'},
  requirement:{sv:'requirement',lb:'Requirement',nm:'qmi',vf:'rid',df:'nam',rf:'qmn'},
  
  uidoc:{sv:'uidoc',lb:'UI Document',nm:'dci',vf:'rid',df:'nam',rf:'dcn'},
  uipage:{sv:'uipage',lb:'UI Page',nm:'pgi',vf:'rid',df:'nam',rf:'pgn'},
  uisection:{sv:'uisection',lb:'UI Section',nm:'sci',vf:'rid',df:'nam',rf:'scn'},
  uidevice:{sv:'uidevice',lb:'UI Device',nm:'dvi',vf:'rid',df:'nam',rf:'dvn'},
  uilang:{sv:'uilang',lb:'UI Language',nm:'lgi',vf:'rid',df:'nam',rf:'lgn'},
  //upload
  filegroup:{sv:'filegroup',lb:'Group',nm:'gpi',vf:'rid',df:'nam',rf:'gpn'},
};

const servicelist:any = [
  ['idv','ID Verification'],
  ['idv-poa','ID+POA Verification'],
  ['facematch','Liveness+Facematch'],
  ['facematch-id','Liveness+Facematch+ID'],
  ['facematch-id-poa','Liveness+Facematch+ID+POA'],
  ['videomatch','Videomatch'],
  ['photomatch','Photomatch'],
  ['regmatch','Regmatch']
]

const lcs:any = {
  branch: { lb: 'Branch', nm: 'bri', vf: 'rid', df: 'nam', et: 'Select', sd: [['0', 'Default']] },
  context: { lb: 'Context', nm: 'ctx', vf: 'rid', df: 'nam', et: 'Select', sd: [[1, 'Default'], [2, 'Ordering'], [4, 'Production'], [8, 'Distribution'], [16, 'Installation'], [32, 'Maintenance']] },
  credit: { lb: 'Credit', nm: 'cre', vf: 'rid', df: 'nam', et: 'Select', sd: [[1, '1 HR'], [2, '2 HRS'], [3, '3 HRS'], [4, '4 HRS'], [5, '5 HR'], [6, '6 HRS'], [7, '7 HRS'], [8, '8 HRS']] },
  country: { lb: 'Country', nm: 'coi', vf: 'rid', df: 'nam', et: 'Select', sd: [['1', 'Ghana'], ['2', 'Nigeria'], ['3', "Cote D'Ivoire"]] },
  format: { lb: 'Format', nm: 'fmt', vf: 'rid', df: 'nam', et: 'Select', sd: [['pdf', 'Portable Document(PDF)'], ['csv', 'Comma Separated(CSV)']] },
  gender: { lb: 'Gender', nm: 'gdi', vf: 'rid', df: 'nam', et: 'Select', sd: [[1, 'Male'], [0, 'Female']] },
  regstatus: { lb: 'Registration', nm: 'rst', vf: 'rid', df: 'nam', et: 'Select', sd: [[1, 'Registered'], [0, 'Unregistered']] },
  reporttype: { lb: 'Report Type', nm: 'rpt', vf: 'rid', df: 'nam', et: 'Select', sd: [['sum', 'Summary'], ['det', 'Detail']] },
  service: { lb: 'Service', nm: 'svc', vf: 'rid', df: 'nam', et: 'Select', sd: servicelist },
  status: { lb: 'Status', nm: 'sts', vf: 'rid', df: 'nam', et: 'Select', sd: [[1, 'Enabled'], [0, 'Disabled'], [2, 'Locked']] },
  title: { lb: 'Title', nm: 'tti', vf: 'rid', df: 'nam', et: 'Select', sd: [[3, 'Dr.'], [2, 'Mrs.'], [1, 'Mr.'], [0, 'Miss']] },
  sector: { lb: 'Sector', nm: 'sci', vf: 'rid', df: 'nam', et: 'Select', sd: [['0', 'Default']] },
};

function basic(service:string){
  return bcs[service];
}

function local(service:string){
  return lcs[service];
}

function combo(service:string){
  return bcs[service] || lcs[service];
}

function combox(type:string,service:string){
  return {bcs,lcs}[type][service];
}

export {bcs, lcs, basic, local, combo};
export default combox;
